import { h } from 'preact'
import { tagParser, safeHtml } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileArgument = ({ title, backgroundColor = '', mentions, icon, CTA: { analytics, URL, target } }) => {
   const hasBackgroundColor = backgroundColor && backgroundColor.trim() !== ''

   const styleOverride = hasBackgroundColor
      ? {
           backgroundColor: backgroundColor,
        }
      : {}

   return (
      <a href={URL} target={target} class="tuile-argument lien-composite" style={styleOverride} {...attributesAnalytics(analytics)}>
         <span class={`icon icon-${icon}`}></span>
         <h3 class="h4 title m-0 p-0" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title)) }} />
         <span class="mentions m-0 p-0">{mentions}</span>
      </a>
   )
}
